import React from 'react';

var _path;

var SvgActivitiesMajor = function SvgActivitiesMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.111.221a3.04 3.04 0 0 1 1.002.66h-.003a2.992 2.992 0 0 1 .89 2.18c-.224 14.324-4.22 16.692-16.931 16.94h-.06c-.797 0-1.548-.31-2.12-.88A2.989 2.989 0 0 1 0 16.937C.226 2.615 4.22.248 16.932 0c.404-.005.805.07 1.179.221zM7.879 7.88a1 1 0 0 1 1.414 0l.708.707 1.414-1.414-.707-.707a1 1 0 0 1 1.414-1.414l.707.707 1.464-1.465a1 1 0 1 1 1.415 1.414l-1.465 1.465.707.707a1 1 0 0 1-1.414 1.414l-.707-.707L11.415 10l.707.707a1 1 0 1 1-1.414 1.415L10 11.415l-1.415 1.414.707.707A1 1 0 1 1 7.88 14.95l-.707-.707-1.464 1.464a1 1 0 0 1-1.415-1.414l1.465-1.464-.707-.707a1 1 0 1 1 1.414-1.415l.707.707L8.586 10l-.707-.707a1 1 0 0 1 0-1.414z"
  })));
};

export { SvgActivitiesMajor as S };
